import { APPLINK_CONFIGURED, SET_DEEP_LINK_PARAMS } from "./actionTypes";

const initialState = {
  applinkHash: "",
  lastSyncTime: null,
  applinkData: {},
  status: {
    didNavigate: false,
    appInstallEventFired: false,
  },
  deepLinkParams: {},
  appLinkClickId: null,
  referer: null,
  hashResult: null,
  longLink: null,

  APPLINK_CONFIGURED: false,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DEEP_LINK_PARAMS:
      return { ...state, deepLinkParams: action.params || {} };
    case "SET_APPLINK":
      return {
        ...initialState,
        applinkHash: action.payload,
      };
    case "DEEPLINK_HANDLED": {
      return { ...state, status: { ...state.status, deepLinkHandled: true } };
    }
    case "APPLINK_INSTALL_FIRED": {
      return {
        ...state,
      };
    }
    case "SET_APP_LINK_CLICK_ID": {
      return {
        ...state,
        appLinkClickId: action.payload,
      };
    }
    case "CLEAR_APP_LINK_CLICK_ID": {
      return {
        ...state,
        appLinkClickId: null,
      };
    }
    case "SET_REFERER": {
      return {
        ...state,
        referer: action.payload,
      };
    }
    case APPLINK_CONFIGURED: {
      return { ...state, APPLINK_CONFIGURED: true };
    }
    case "SET_HASH_RESULT": {
      return { ...state, hashResult: action.payload };
    }
    default:
      return state;
  }
}

reducer.initialState = {
  ...initialState,
};
export default reducer;
